export enum InvoiceVersion {
  THREE_POINT_ZERO = '3.0'
}

export enum InvoiceSourceEnum {
  WEB = 'Web',
  MOBILE = 'Mobile'
}

export enum InvoiceTimelineCTAActions {
  SHARE_INVOICE = 'share-invoice'
}

export const INVOICE_STATUS_FILTER = [
  {
    label: 'Paid',
    value: 'PAID-QR, PAID'
  },
  {
    label: 'Pending',
    value: 'PENDING, PROCESSING'
  }
  // {
  //   label: 'Refunded',
  //   value: 'REFUNDED, REFUND_INITIATED'
  // }
];
